import { createSelector } from "@reduxjs/toolkit";

const getPropertiesState = (state) => state.properties;

export const getPropertiesByProjectSelector = createSelector(
  [getPropertiesState],
  (properties) => properties.propertiesByProject
);

export const getPropertiesByProjectCountSelector = createSelector(
  [getPropertiesState],
  (properties) => properties.propertiesByProjectCount
);
